import Head from 'next/head'

interface MetadataProps {
  metadata: {
    metaTitle?: string
    title?: string
    description?: string
    canonical?: string
    og?: {
      type?: string
      title?: string
      description?: string
      url?: string
      image?: string
      updatedAt?: string
      tag?: string
      facebookUrl?: string
    }
    twitter?: {
      title?: string
      description?: string
      url?: string
      image?: string
      creator?: string
    }
  }
}

export default function BlogMeta({ metadata }: MetadataProps) {
  const title = metadata.metaTitle || metadata.title

  return (
    <Head>
      <title>{`${title ? `${title} |` : ''} Kickoff`}</title>
      {metadata.description && (
        <meta name="description" content={metadata.description} />
      )}
      {metadata.canonical && (
        <link rel="canonical" href={metadata.canonical} key="canonical" />
      )}
      <meta name="referrer" content="no-referrer-when-downgrade" />
      {/* og metas */}
      {metadata.og && (
        <>
          <meta property="og:site_name" content="Kickoff" />
          <meta property="og:type" content={metadata.og.type} />
          <meta property="og:title" content={metadata.og.title} />
          <meta property="og:description" content={metadata.og.description} />
          <meta property="og:url" content={metadata.og.url} />
          <meta property="og:image" content={metadata.og.image} />
          {metadata.og.updatedAt && (
            <meta
              property="article:published_time"
              content={metadata.og.updatedAt}
            />
          )}
          {metadata.og.updatedAt && (
            <meta
              property="article:modified_time"
              content={metadata.og.updatedAt}
            />
          )}
          {metadata.og.tag && (
            <meta property="article:tag" content={metadata.og.tag} />
          )}
          {metadata.og.type === 'article' && (
            <meta
              property="article:publisher"
              content="https://www.facebook.com/trainwithkickoff"
            />
          )}
        </>
      )}
      {metadata.og.type === 'aritcle' && (
        <meta
          property="article:author"
          content={
            metadata.og.facebookUrl ||
            'https://www.facebook.com/trainwithkickoff'
          }
        />
      )}
      {/* twiiter metas */}
      {metadata.twitter && (
        <>
          <meta name="twitter:card" content="summary_large_image" />
          <meta property="twitter:title" content={metadata.twitter.title} />
          <meta
            property="twitter:description"
            content={metadata.twitter.description}
          />
          <meta property="twitter:url" content={metadata.twitter.url} />
          <meta property="twitter:image" content={metadata.twitter.image} />
          {/* <meta property="twitter:site" content={metadata.twitter.publisher} /> */}
          <meta property="twitter:creator" content={metadata.twitter.creator} />
        </>
      )}
    </Head>
  )
}
